import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoPatologia(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [postNombre, setPostNombre] = useState("");
  const [postServicio, setPostServicio] = useState("");
  const [postCargo, setPostCargo] = useState("");
  const [postLider, setPostLider] = useState("");

  const handleOpenModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const postData = (e) => {
    e.preventDefault();
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoPatologia",
      data: {
        nombre: postNombre,
        servicio: postServicio,
        cargo: postCargo,
        lider: postLider,
        SolicitudId: props.idSolicitud,
      },
    })
      .then((response) => {
        alert("Añadido con éxito!");
        closeModal(); // cerrar modal
        props.onSuccess(); // recargar tabla automáticamente
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear registro: " + error);
      });
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={handleOpenModal}>
        Nueva
      </button>
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <div className="container">
          <br></br>
          <br></br>
          <h5>Crear Equipo de Patología</h5>
          <form onSubmit={postData}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Nombre"
                className="form-control"
                onChange={(e) => setPostNombre(e.target.value)}
              />
            </div>
            <div className="form-group row">
              <div className="col-sm-6">
                <input
                  type="text"
                  placeholder="Servicio"
                  className="form-control"
                  onChange={(e) => setPostServicio(e.target.value)}
                />
              </div>
              <div className="col-sm-6">
                <input
                  type="text"
                  placeholder="Cargo"
                  className="form-control"
                  onChange={(e) => setPostCargo(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group">
              <select
                className="form-control"
                onChange={(e) => setPostLider(e.target.value)}
              >
                <option value="">Es Líder?</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </select>
            </div>
            <div className="mt-3">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={closeModal}
              >
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary">
                Guardar
              </button>
            </div>
          </form>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaEquipoPatologia;
